import { createAction } from "redux-actions";
import { DPF_GET_TYPE_DEPOSITS } from "../constants";
import { feathersCreateData } from "../services";

export const getDPFTypeDeposits = createAction(DPF_GET_TYPE_DEPOSITS, () => feathersCreateData('core-server',{
    service: 'DEPOSITS',
    func: 'DPF_GET_TYPE_DEPOSITS'
})())
